import { render, staticRenderFns } from "./LocalReconAdmin.vue?vue&type=template&id=646615c3"
import script from "./LocalReconAdmin.vue?vue&type=script&lang=js"
export * from "./LocalReconAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports